<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_return_tab_month_item') }} </v-tab>
      <v-tab-item value="tab-1">
        <!-- 使用 UnlimitedMonthSetting 組件，不包含 discount 和 Bom -->
        <unlimited-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import UnlimitedMonthSetting from '@/components/Quotation/MonthItem/UnlimitedMonthSetting.vue'
export default {
  components: { UnlimitedMonthSetting },
  name: 'UnlimitedMonth',

  data: () => ({}),
  watch: {
    carQuantity (val) {
      if (this.monthItemList.length > 0) {
        // 深拷貝後修改，避免直接 mutate prop
        const updatedList = JSON.parse(JSON.stringify(this.monthItemList))
        updatedList.forEach((element) => {
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
        this.$emit('setAllMonth', updatedList)
      }
    }
  },
  methods: {
    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType'
  ]
}
</script>
